/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pencil': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M42.227 3.978c-3.7-3.97-9.727-3.97-13.428 0L4.19 30.298a1.31 1.31 0 0 0-.343.76L2.013 45.505c-.057.417.08.821.344 1.103.229.245.55.392.87.392.058 0 .115 0 .16-.012l8.135-1.177c.676-.098 1.157-.76 1.066-1.495-.092-.723-.71-1.237-1.398-1.14l-6.53.944L5.93 34.048l9.922 10.612c.23.245.55.392.87.392.322 0 .642-.135.871-.392l24.622-26.321C44.014 16.415 45 13.866 45 11.159c.023-2.721-.974-5.27-2.773-7.181zM29.281 7.213l4.136 4.423-22.468 24.03-4.136-4.424 22.468-24.03zm-12.534 34.64l-4.045-4.325 22.467-24.03 4.045 4.326-22.467 24.03zm24.197-25.916L31.045 5.362c1.26-1.103 2.818-1.715 4.468-1.715 1.88 0 3.644.784 4.973 2.193 1.329 1.41 2.05 3.309 2.05 5.318a7.705 7.705 0 0 1-1.592 4.78z" _fill="#000"/>'
  }
})
